export default __webpack_public_path__ + "static/media/paige-large.6abb2211.png";